<script setup="">
import { computed } from "vue";
import { useToast } from "vue-toastification";

import SimpleTextarea from "@/Components/Form/SimpleTextarea.vue";
import ProfileChooser from "@/Components/ProfileChooser.vue";

import { router } from "@inertiajs/vue3";

const props = defineProps({
  campaign: {
    type: Object,
    required: true
  },
  update: {
    type: Function,
    required: true
  }
});

const toast = useToast();

const title = computed({
  get: () => props.campaign.title,
  set: (value) => props.update("title", value)
});

const message = computed({
  get: () => props.campaign.message,
  set: (value) => props.update("message", value)
});

const uploadProfile = (file) => {
  const formData = new FormData();
  formData.append("file", file);

  axios
    .post(route("app.ajax.campaigns.upload.profile-photo", props.campaign.team), formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })
    .then(() => {
      router.visit(route("app.campaigns.index", props.campaign.team));
    });
};

const deleteProfile = () => {
  axios.delete(route("app.ajax.campaigns.delete.profile-photo", props.campaign.team)).then(() => {
    router.visit(route("app.campaigns.index", props.campaign.team));
  });
};
</script>

<template>
  <div class="space-y-4">
    <div>
      <ProfileChooser
        :model-value="campaign.profile_photo_url"
        :max-size="1024"
        description="이미지는 1MB 이하 (권장 사이즈: 200x200(px))"
        :width="80"
        :height="80"
        :hide-delete-for-urls="['ui-avatars.com']"
        @clear="deleteProfile"
        @selected="uploadProfile"
      />
    </div>

    <SimpleTextarea v-model="title" label="캠페인 타이틀" input-class="h-24 resize-none pr-10" label-class="text-600 text-sm" max-length="32" />

    <SimpleTextarea v-model="message" label="캠페인 메시지" input-class="h-24 resize-none pr-10" label-class="text-600 text-sm" max-length="64" />
  </div>
</template>
